// extracted by mini-css-extract-plugin
module.exports = {"container":"history_container__UiAib","header":"history_header__RVe6n","icon":"history_icon__FR62L","title":"history_title__WX7cQ"};